// Set index of Page.Row being currently edited
// This allows every component interested to know the current row to
// access it (e.g Canvas, Component Editor...etc)
export const setEditRowIndex = (state, action) => {
  return {
    ...state,
    activeRowIndex: action.payload.rowIndex
  };
};
